


    //$.fuiLoader = $("#loader")
    //const loader = null 
    //const apiUrl = $.fuiApiUrl 
    //const baseUrl = $.fuiBaseUrl

    const urlSq = function(){
      return "&dateSq" + Date.parse(new Date())
    }

    const showLoader = function () {
      if ($.fuiLoaderTimeout) clearTimeout($.fuiLoaderTimeout)
      $.fuiLoaderTimeout = setTimeout(() =>{
        //$.fuiLoader.show()
        //console.log(this.$loader.style)
       if (window.$fuiLoader) window.$fuiLoader.style.display = "block"
      }, 300);
    }
    const hideLoader = function () {
      if ($.fuiLoaderTimeout) clearTimeout($.fuiLoaderTimeout) 
      //$.fuiLoader.hide()
        //console.log(this.$loader)
      if (window.$fuiLoader) window.$fuiLoader.style.display = "none"
    }

    const initRights = function (config) {
      if (!config) return
      this.$showLoader()
       $.ajax({
        type: "get",
        url: this.$apiUrl + config.url + 'rights?' + this.$urlSq(),
        contentType: "application/json",
        dataType: "json",
        timeout: 120000,
        async: false,
        success:data=>{
          this.$hideLoader()
        if (data.rs) {
          $.extend(config, data)
        } else {
          this.$sysError();
        }
      },
      error: e=>{
          this.$hideLoader()
          this.$sysError();
        }
      })
    }

    const save = function (url, data, callback) {
      this.$showLoader()
      let rs = false;
      $.ajax({
        type: "post",
        url: this.$apiUrl + url,
        contentType: "application/json",
        data: JSON.stringify(data),
        dataType: "json",
        timeout: 120000
      }).then(
        rs=>{
          this.$hideLoader()
          //if (rs.rs == 1) {
          //  this.$saveSuccess()
          //} 
          if (rs.rs == 0) {
            console.log("Save error:" + rs.rs)
            this.$sysError();
          } 
          if(callback) callback(rs)
        },
        e=>{
          console.log(e)
          this.$hideLoader()
          if(callback) callback(false)
        }
      )
    }

    const getParamsFromList=function(config){
      const params = {}
      params.pageNo = config.pageNo
      params.pageSize = config.pageSize
      params.sortName = config.sortName
      params.sortOrder = config.sortOrder
      params.Items = []
      if (config.params){
        Object.keys(config.params).forEach(Key => {
          const tmp = config.params[Key]
          if (tmp.data) {
            tmp.data = $.trim(tmp.data)
            if (tmp.data != "") params.Items.push({
              Key,
              Field: tmp.key,
              Value: tmp.data,
              Smethod: tmp.method
            })
          }
        })
      }
      
      return params
    }

    const delAndReload = function (url, data, config, callback) {
      const params =this.$getParamsFromList(config)
      this.$delete(url, {data, params}, callback)
    }

    const deletef = function (url, data, callback) {
      this.$showLoader()
      let rs = false;
      $.ajax({
        type: "post",
        url: this.$apiUrl + url + "delete",
        contentType: "application/json",
        data: JSON.stringify(data),
        dataType: "json",
        timeout: 120000,
        success: data => {
          rs = data
        }
      }).then(
        rs=>{
          this.$hideLoader()
            if (rs.rs) {
              //this.$delSuccess()
              if(callback) callback(rs)
            } else {
              console.log("delete error:" + rs.rs)
              this.$sysError();
              if(callback) callback(false)
            }
        },
        e=>{
          this.$hideLoader()
          console.log("delete error:" + e)
          this.$sysError();
          if(callback) callback(false)
        }
      )
      
    }

    const loadData = function (config, pageNo, pageSize) {
      if (!config) return
      const params = {}
      params.pageNo = pageNo ? pageNo : config.pageNo
      params.pageSize = pageSize ? pageSize : config.pageSize
      params.sortName = config.sortName
      params.sortOrder = config.sortOrder
      if (config.sorts) params.sorts = config.sorts
      params.Items = []
      Object.keys(config.params).forEach(Key => {
        const tmp = config.params[Key]
        /*let Value=!tmp.data?$.trim(tmp.data):null;
        if (Value=="")Value = null;
        params.Items.push({
          Key,
          Field: tmp.key,
          Value,
          Smethod: tmp.method
        })*/

        if (tmp.data) {
          tmp.data = $.trim(tmp.data)
          if (tmp.data != "") params.Items.push({
            Key,
            Field: tmp.key,
            Value: tmp.data,
            Smethod: tmp.method
          })
        }
      })

      // params.params = []

      /*Object.keys(config.params).forEach(key => {
        const tmp = config.params[key]
        if (tmp.data) {
          tmp.data = $.trim(tmp.data)
          if (tmp.data != "") params.params.push({
            key: tmp.key,
            data: tmp.data,
            method: tmp.method
          })
        }
      })*/


      this.$showLoader()
      $.ajax({
        type: "post",
        url: this.$apiUrl + config.url + "index",
        contentType: "application/json",
        data: JSON.stringify(params),
        dataType: "json",
        timeout: 120000
      }).then(data => {
        //console.log("data.rs:" + data.rs)
        if (data.rs) {
          $.extend(config, data)
          //if (sf) config.sortName= sf
        }
        else if (data.rs==-2){
          this.$alert(this.$rs["msg_no_rights"])
        } else {
          this.$sysError();
        }
        this.$hideLoader()
      }, (e) => {
        if (e.status == 403) this.$alert(this.$rs["msg_no_rights"])
        else this.$sysError();
        //console.log("load error:")
        console.log(e)
        this.$hideLoader()
      })

    }

    const getData=function (url, callback, sync){
      this.$showLoader()
      if (sync!==false) sync=true
      $.ajax({
        type: "get",
        url: this.$apiUrl + url,
        dataType: "json",
        async: false,
        timeout: 120000,
        success:(data)=>{
          this.$hideLoader()
          if(callback) callback(data)
          else DefaultCallBack(data)
        },
        error: (e)=>{
          console.log("GetDate error:" + e.description)
          this.$sysError();
          this.$hideLoader()
          return null

        }
      })
    }

    const postData=function (url, params, callback){
      this.$showLoader()
      $.ajax({
        type: "post",
        data: JSON.stringify(params),
        url: this.$apiUrl + url,
        contentType: "application/json",
        dataType: "json",
        timeout: 120000
      }).then(data => {
        this.$hideLoader()
        if(callback) callback(data)
        else DefaultCallBack(data)
      }, (e) => {
        console.log("PostData error:" + e.description)
        this.$sysError();
        this.$hideLoader()
        return null
      })
    }

    function DefaultCallBack(data){
      if (data.rs=1) this.$alert(this.$rs["msg_action_success"])
      else this.$sysError()
    }

    const createExport = function (config, exType, callback) {
      if (!config) return
      const v = $.vue;
      const params = {}
      params.Items = []
      params.sortName = config.sortName
      params.sortOrder = config.sortOrder
      Object.keys(config.params).forEach(Key => {
        const tmp = config.params[Key]
        if (!tmp.data || $.trim(tmp.data))
          if (tmp.data) {
            tmp.data = $.trim(tmp.data)
            if (tmp.data != "") params.Items.push({
              Key,
              Field: tmp.key,
              Value: tmp.data,
              Smethod: tmp.method
            })
          }
      })

      this.$showLoader()
      $.ajax({
        type: "post",
        url: this.$apiUrl + config.url + "ExportTo" + exType,
        contentType: "application/json",
        data: JSON.stringify(params),
        dataType: "json",
        timeout: 120000
      }).then(data => {
        this.$hideLoader()
        if (data.rs) {
          if(callback) callback(data.file, data.ename)
        } else {
          this.$sysError();
          return null
        }
      }, (e) => {
        console.log("load error:" + e.description)
        this.$sysError();
        this.$hideLoader()
        return null
      })

    }
    const sortData = function (e, config, sn) {
      let el = e.target
      if (el.tagName == "SPAN") el = el.parentNode

      if (el.getAttribute("class") === "sort-column") {
        if (!sn) sn = el.getAttribute("sortName")
        if (sn) {
          const xl = el.parentNode.querySelector(".glyphicon")
          if (xl && xl !== el) xl.setAttribute("class", "sort-icon")
          const sicon = el.querySelector(".sort-icon")
          if (sn == config.sortName) {
            if (config.sortOrder == "asc") {
              config.sortOrder = "desc"
              if (sicon) sicon.setAttribute("class", "sort-icon glyphicon glyphicon-sort-by-attributes-alt")
            } else {
              config.sortOrder = "asc"
              if (sicon) sicon.setAttribute("class", "sort-icon glyphicon glyphicon-sort-by-attributes")
            }

          } else {
            config.sortName = sn
            config.sortOrder = "asc"
            if (sicon) sicon.setAttribute("class", "sort-icon glyphicon glyphicon-sort-by-attributes")
          }
          this.$loadData(config, undefined, undefined)
        }
      }
    }

    

export default {
  loader:null,
  urlSq,
  showLoader,
  hideLoader,
  initRights,
  save:save,
  getParamsFromList,
  delAndReload,
  delete:deletef,
  loadData,
  getData,
  postData,
  createExport,
  sortData
}
